import React from 'react';

import { Pagination } from '@components/Pagination';
import { useSearch } from '@hooks/next/useSearch';
import { PaginationType } from '@models/next/PaginationType';
import { UseQueryResult } from '@tanstack/react-query';
import { DEFAULT_PAGE_SIZE } from '@utils/types';

export interface PaginationWithSearchQueryProps {
  query: UseQueryResult<{ count: number }>;
  pageSize?: number;
}

export const PaginationWithSearchQuery: React.FC<PaginationWithSearchQueryProps> = (props) => {
  const { query, pageSize } = props;

  const { updateSearch, search } = useSearch(PaginationType);

  if (!query.data) return null;

  const itemCount = query.data.count;
  const pageCount = Math.ceil(itemCount / (pageSize ?? search.page_size ?? DEFAULT_PAGE_SIZE));
  const page = (search.page ?? 1) - 1;

  return (
    <Pagination
      page={Math.min(Math.max(page, 0), pageCount - 1)}
      count={pageCount}
      onChange={(page) => updateSearch({ page: page + 1 })}
    />
  );
};
